<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CopyBillingListItems"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="formMode"
        :label="'Mode'|pgettext('CopyBillingListItems')"
        labelColsMd="3"
        contentColsMd="8"
        :labelAlign="labelAlign"
      >
        <BFormRadio
          :key="mode.vaue"
          v-model="selectedMode"
          name="formMode"
          :value="mode.value"
          v-for="mode in formModes"
        >
          {{ mode.name }}
        </BFormRadio>
      </ItpFormGroup>
      <ItpFormGroup
        name="product"
        :label="'Service'|pgettext('CopyBillingListItems')"
        labelColsMd="3"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group  d-flex flex-row"
        :helpTooltip="fieldsByName['product'].help"
        v-if="isFieldVisible('product')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="product_enabled"
              v-model="item.$updates.product"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect2
          name="product"
          v-model="item.product"
          bind-object
          :dataSource="b_814138253067422_dataSource"
          textField="name"
          :disabled="!item.$updates.product"
          class="flex-grow-1"
          @optionSelected="evh_814138253067422_optionSelected($event, {})"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="description"
        :label="'Description'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['description'].help"
        class="col"
        v-if="isFieldVisible('description')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="description_enabled"
              v-model="item.$updates.description"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          name="description"
          v-model="item.description"
          :disabled="!item.$updates.description"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="intermediated_service"
        :label="'Intermediated service'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['intermediated_service'].help"
        class="col"
        v-if="isFieldVisible('intermediated_service')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="intermediated_service_enabled"
              v-model="item.$updates.intermediated_service"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <div
          class="input-group-text"
        >
          <ItpFormCheckbox
            name="intermediated_service"
            v-model="item.intermediated_service"
            :disabled="!item.$updates.intermediated_service"
          >
          </ItpFormCheckbox>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="quantity"
        :label="'Quantity'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['quantity'].help"
        class="col"
        v-if="isFieldVisible('quantity')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="quantity_enabled"
              v-model="item.$updates.quantity"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="4"
          name="quantity"
          v-model="item.quantity"
          :disabled="!item.$updates.quantity"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="quantity_percentage"
        :label="'Quantity %'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="3"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['quantity_percentage'].help"
        appendText="%"
        class="col"
        v-if="isFieldVisible('quantity_percentage')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="quantity_percentage_enabled"
              v-model="item.$updates.quantity_percentage"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="4"
          name="quantity_percentage"
          v-model="item.quantity_percentage"
          :disabled="!item.$updates.quantity_percentage"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="unit"
        :label="'Unit'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['unit'].help"
        class="col"
        v-if="isFieldVisible('unit')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="unit_enabled"
              v-model="item.$updates.unit"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          name="unit"
          v-model="item.unit"
          :disabled="!item.$updates.unit"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="price"
        :label="'Price'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['price'].help"
        class="col"
        v-if="isFieldVisible('price')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="price_enabled"
              v-model="item.$updates.price"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="2"
          name="price"
          v-model="item.price"
          :disabled="!item.$updates.price"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="price_percentage"
        :label="'Price %'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="3"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['price_percentage'].help"
        appendText="%"
        class="col"
        v-if="isFieldVisible('price_percentage')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="price_percentage_enabled"
              v-model="item.$updates.price_percentage"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="4"
          name="price_percentage"
          v-model="item.price_percentage"
          :disabled="!item.$updates.price_percentage"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="discount_percentage"
        :label="'Discount %'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="3"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['discount_percentage'].help"
        appendText="%"
        class="col"
        v-if="isFieldVisible('discount_percentage')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="discount_percentage_enabled"
              v-model="item.$updates.discount_percentage"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="4"
          name="discount_percentage"
          v-model="item.discount_percentage"
          :disabled="!item.$updates.discount_percentage"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('Invoice')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
        contentClass="input-group"
        :helpTooltip="fieldsByName['notes'].help"
        class="col"
        v-if="isFieldVisible('notes')"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="notes_enabled"
              v-model="item.$updates.notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :disabled="!item.$updates.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CopyBillingListItems extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_selectedMode = new ComponentValueCache(this, "selectedMode", "CopyBillingListItems.selectedMode");
  }

  getItem(...args: any[]) {
    const [sources, fields] = args;
    const fieldNames = _.map(fields, 'name');

    let result = _.reduce(fieldNames, (m, v) => _.set(m, v, null), {})
    result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {})

    return result;
  }

  getPayload(...args: any[]) {
    const [sources, item] = args;

    const updates = _.intersection(
      _.keys(_.pickBy(item.$updates, _.identity)),
      this.getVisibleFields()
    );

    if (!updates.length) {
      return
    }

    return { ..._.pick(item, updates), sources };
  }

  onProductSelected(...args: any[]) {
    const [data] = args;

    if (!data.name) {
      return;
    }

    this.item.description = data.name;
    this.item.$updates['description'] = true;

    this.item.unit = data.unit;
    this.item.$updates['unit'] = true;
  }

  getVisibleFields(...args: any[]) {
    const selectedMode = this.selectedMode
    return _
      .chain(this.fields)
      .filter(field => !_.isArray(field.mode) || field.mode.indexOf(selectedMode) > -1)
      .map('name')
      .value()
  }

  isFieldVisible(...args: any[]) {
    const [name] = args;
    const mode = _.get(this.fieldsByName[name], 'mode')

    if (_.isArray(mode)) {
      return mode.indexOf(this.selectedMode) > -1;
    }

    return true;
  }

  @Prop({
    type: Array,
  })
  sources!: array;

  @Watch('sources')
  onSources(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("sources")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  isReadonly!: any;
  formModes!: any;
  selectedMode!: any;
  fields!: any;
  fieldsByName!: any;

  async $$load_fieldsByName() {
    return _.keyBy(this.$data.fields, 'name')
  }

  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.getItem(this.sources, this.$data.fields)
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_814138253067422_dataSource!: any;
  dataMembers = ['isReadonly', 'formModes', 'selectedMode', 'fields', 'fieldsByName', 'labelAlign', 'formId', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_814138253067422_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        isReadonly: false,
        formModes: [{
          value: "discount",
          name: this.$fn.pgettext("CopyBillingListItems", "Simple discount"),
        }
          ,
        {
          value: "complex",
          name: this.$fn.pgettext("CopyBillingListItems", "Complex calculations"),
        }
          ,
        ]
        ,
        selectedMode: "discount",
        fields: [{
          name: "product",
          help: this.$fn.pgettext("CopyBillingListItems", "Override the product or service reference for this line."),
        }
          ,
        {
          name: "description",
          help: this.$fn.pgettext("CopyBillingListItems", "Override the line description with any freeform text."),
        }
          ,
        {
          name: "intermediated_service",
          help: this.$fn.pgettext("CopyBillingListItems", "Set or override whether this line represents an intermediated service."),
        }
          ,
        {
          name: "unit",
          help: this.$fn.pgettext("CopyBillingListItems", "The unit to use to generate the new items."),
          mode: ["discount"
            ,
            "complex"
            ,
          ]
          ,
        }
          ,
        {
          name: "quantity",
          help: this.$fn.pgettext("CopyBillingListItems", "Define a fixed quantity to use when generating the new items."),
          mode: ["complex"
            ,
          ]
          ,
        }
          ,
        {
          name: "quantity_percentage",
          help: "P_(\"CopyBillingListItems\", \"Specify the quantity as a percentage of the original item’s quantity.\")",
          mode: ["complex"
            ,
          ]
          ,
        }
          ,
        {
          name: "price",
          help: this.$fn.pgettext("CopyBillingListItems", "Set a fixed price to apply to the new items, overriding the original price."),
          mode: ["complex"
            ,
          ]
          ,
        }
          ,
        {
          name: "price_percentage",
          help: "P_(\"CopyBillingListItems\", \"Set the price as a percentage of the original item’s price.\")",
          mode: ["complex"
            ,
          ]
          ,
        }
          ,
        {
          name: "discount_percentage",
          help: this.$fn.pgettext("CopyBillingListItems", "Apply a discount percentage to the new items."),
          mode: ["discount"
            ,
          ]
          ,
        }
          ,
        {
          name: "notes",
          help: this.$fn.pgettext("CopyBillingListItems", "Add or override the internal notes for the generated invoice line."),
        }
          ,
        ]
        ,
        fieldsByName: null,
        labelAlign: "right",
        formId: null,
        formName: "CopyBillingListItems",
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_814138253067422_dataSource: {
          name: "suggest_product",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("CopyBillingListItems|Title", "Copy Billing List Items"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2214_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2214, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_2220_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2220, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_2218_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_2218, alias=save
    return {
      operation: "copy_billing_list_items",
      data: this.getPayload(this.sources, this.item),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_814138253067422_script_2222_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_814138253067422_script_2222, alias=undefined
    this.onProductSelected($event.data.option)
  }

  async act_814138253067422_script_2222_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_814138253067422_script_2222, alias=undefined
    return {
      value: () => this.act_814138253067422_script_2222_getActionArgs_value($event),
    }
  }

  async evh_814138253067422_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_814138253067422_optionSelected.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2214: actions.CloseModalAction;
    evh_7315092382398562_close_2213: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2216: actions.CloseComponentAction;
    evh_2248226175642056_close_2215: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_2220: actions.CloseComponentAction;
    evh_1040167445267876_success_2219: actions.EventHandlerImpl;
    act_1040167445267876_request_2218: actions.RequestAction;
    evh_1040167445267876_submit_2217: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_814138253067422_script_2222: actions.ScriptAction;
    evh_814138253067422_optionSelected_2221: actions.EventHandlerImpl;
    evh_814138253067422_optionSelected: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2224: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2223: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2214 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2214_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2213 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2214,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2213],
      }
    );
    const act_2248226175642056_closeComponent_2216 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2215 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2216,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2215],
      }
    );
    const act_1040167445267876_closeComponent_2220 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2220_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2219 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2220,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_request_2218 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_2218_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_2219],
      }
    );
    const evh_1040167445267876_submit_2217 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_2218,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2217],
      }
    );
    const act_814138253067422_script_2222 = new actions.ScriptAction(
      {
        actionArgs: this.act_814138253067422_script_2222_getActionArgs,
        events: [],
      }
    );
    const evh_814138253067422_optionSelected_2221 = new actions.EventHandlerImpl(
      {
        action: act_814138253067422_script_2222,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_814138253067422_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_814138253067422_optionSelected_2221],
      }
    );
    const act_1419464017721962_closeComponent_2224 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2223 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2224,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2223],
      }
    );
    return {
      act_7315092382398562_closeModal_2214,
      evh_7315092382398562_close_2213,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2216,
      evh_2248226175642056_close_2215,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_2220,
      evh_1040167445267876_success_2219,
      act_1040167445267876_request_2218,
      evh_1040167445267876_submit_2217,
      evh_1040167445267876_submit,
      act_814138253067422_script_2222,
      evh_814138253067422_optionSelected_2221,
      evh_814138253067422_optionSelected,
      act_1419464017721962_closeComponent_2224,
      evh_1419464017721962_clickPreventStop_2223,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_2218,
    }
  }
}

Vue.component("CopyBillingListItems", CopyBillingListItems);

</script>